import { requestWithRetry, retryConfigs } from '../utils/request';
import request from '../utils/request';
import { PlatformStats } from '../types/stats';

export const getPlatformStats = async (): Promise<PlatformStats> => {
  try {
    console.log('Making API request to /stats');
    // request实例已有自动重试机制
    const response = await request.get('/stats');
    console.log('Raw API response:', response);
    console.log('Response data type:', typeof response);
    console.log('Response data structure:', response);

    if (!response) {
      console.error('No data received from API');
      throw new Error('No data received from API');
    }

    // request实例已经返回response.data，所以直接使用response
    const data = response as any;
    console.log('Processing data:', data);

    // 确保所有字段都存在，如果不存在则使用默认值0
    const stats: PlatformStats = {
      total_loans: Number(data.total_loans || data.totalLoans || 0),
      total_trades: Number(data.total_trades || data.totalTrades || 0),
      total_withdrawals: Number(data.total_withdrawals || data.totalWithdrawals || 0),
      active_users: Number(data.active_users || data.activeUsers || 0),
      total_profits: Number(data.total_profits || data.totalProfits || 0),
      last_updated: Number(data.last_updated || data.lastUpdated || Date.now())
    };

    console.log('Processed stats:', stats);
    return stats;
  } catch (error: any) {
    console.error('Error fetching platform stats:', error);
    throw error;
  }
}; 